import { useState, useContext, useRef, useEffect } from "react";
import { Box, Popover, Checkbox, Autocomplete, Radio, FormControl, FormControlLabel, RadioGroup, InputAdornment, OutlinedInput, Typography, Avatar, Grid, Tooltip, MenuItem, TextField, Select, Chip } from "@mui/material";
import TitleBar from "../../components/layout-components/TitleBar";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import "./AddProject.scss";
import ColorPickerWithPalettes from "../../components/ColorPickerWithPalettes";
import { ReactComponent as DownArrow } from "../../assets/images/ralvie/dropDown.svg";
import { ReactComponent as ArrowUp } from "../../assets/images/ralvie/ArrowUp.svg";
import CustomizedDatePicker from "../../components/CustomizedDatePicker";
import { useTranslation } from "react-i18next";
import CustomAutoComplete from "../../components/CustomAutoComplete";
import CustomTextField from "../../components/DescriptionBox";
import { ReactComponent as ErrorIcon } from "../../assets/images/ralvie/error-icon.svg";
import { ReactComponent as CloseIconImg } from "../../assets/images/close-icon.svg";
import TagTextField from "./ProjectTagfield";
import AddMembersComponent from "./AddMemberlist";
import Emojipicker from "../tags/Emojipicker";
import TagIcon from "../../assets/images/ralvie/tag-icon-inactive.svg";
import AppContext from "../../config/AppContext";
import CloseIcon from '@mui/icons-material/Close';
import {
    bindPopover,
    bindTrigger,
    usePopupState,
} from "material-ui-popup-state/hooks";
import CancelDialog from "./CancelDialog";
import CustomButton from "../../components/CustomButton";
import { createTag, getAllTags, uploadTagIconById } from "../../services/TagService";
import { clientList, rolesList } from "../../services/MemberService";
import { toast } from "sonner";
import { editProject, getProject } from "../../services/ProjectService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getProjectMember } from "../../services/ProjectMemberService";
import moment from "moment";
import CommonUtil from "../../util/CommonUtils";
import ProjectTagTextField from "./ProjectTagfield";
import { getCompanySetting } from "../../services/CompanySettingService";

export default function AddProject() {

    const navigate = useNavigate();
    const location = useLocation();
    const [isRecurring, setIsRecurring] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const { t, i18n } = useTranslation();
    const [clientId, setClientId] = useState("");
    const [tagIcon, setTagIcon] = useState();
    const fileInputRef = useRef(null);
    const [tagIconFile, setTagIconFile] = useState(null);
    const [error, setError] = useState(null);
    const { mode } = useContext(AppContext);
    const [clients, setClients] = useState([]);
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [selectedEmoji, setSelectedEmoji] = useState(null);
    const [expandedAccordion, setExpandedAccordion] = useState("basic");
    const [selectedOption, setSelectedOption] = useState("");
    const [tagOptions, setTagOptions] = useState([]);
    const [tagSearchValue, SetTagSearchValue] = useState("")
    const [selectedTags, setSelectedTags] = useState([]);
    const [membersList, setMembersList] = useState([]);
    const [savedMemberList, setSavedMemberList] = useState([]);
    const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
    const { id } = useParams();
    const basicAccordionRef = useRef(null);
    const detailsAccordionRef = useRef(null);
    const budgetAccordionRef = useRef(null);
    const membersAccordionRef = useRef(null);
    const selectRef = useRef(null);
    const [isSelectOpen, setIsSelectOpen] = useState(false);
    const [formData, setFormData] = useState({});
    const [loading, isLoading] = useState(false);
    const fromView = location.state ? location.state?.fromView : null;
    const [billableType, setBillableType] = useState("");
    const [defaultBudgetType, setDefaultBudgetType] = useState("");
    const [currentBudgetType, setCurrentBudgetType] = useState("");
    const [isSaveButtonDisable, setSaveButtonDisable] = useState(false);
    const [projectData, setProjectData] = useState({
        name: "",
        color: "#3F9F4A",
        description: "",
        clientName: "",
        startDate: "",
        endDate: "",
        tags: [],
        members: [],
        billableType: "",
        budgetType: "",
        timeBudget: "",
        costBudget: "",
        objective: "",
    });
    const [userList, setUserList] = useState([]);

    const [projectErrors, setProjectErrors] = useState({
        name: "",
        color: "",
        description: "",
        clientName: "",
        projectClientEmail: "",
        startDate: "",
        endDate: "",
        tags: [],
        members: [],
        billableType: "",
        budgetType: "",
        timeBudget: "",
        costBudget: "",
        objective: "",
    });

    const loadTag = () => {
        getAllTags()
            .then((res) => {
                if (res?.data && res?.data?.data && res?.data?.data?.tags) {
                    const sortedTags = res?.data?.data?.tags
                        ?.map((tag) => ({
                            id: tag?.id,
                            name: tag?.name,
                            url: tag?.iconUrl,
                        }))
                        ?.sort((a, b) => a.name.localeCompare(b.name));
                    setTagOptions(sortedTags);
                } else {
                    setTagOptions([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching tag list:", error);
                setTagOptions([]);
            });
    }

    const loadProjectById = (id) => {
        isLoading(true);
        getProject(id)
            .then((response) => {
                if (response.data && response.data.data) {
                    setProjectData({
                        ...response.data?.data,
                        tags: response.data?.data?.tags ? response.data?.data?.tags?.map(tg => tg.id) : []
                    });
                    setCurrentBudgetType(response.data?.data?.budgetType);
                    setFormData({ ...response.data?.data, isRecurringEndDate: response.data?.data?.endDate ? false : true })
                    setSelectedTags(response.data?.data?.tags ? response.data?.data?.tags?.map(tg => tg.id) : [])
                    setClientId(response.data?.data?.client?.id);
                    setIsRecurring(response.data?.data?.endDate ? false : true);
                    setBillableType(response.data?.data?.billableType);
                } else {
                    console.log("No project data received:", response); // Log unexpected response structure
                }
                isLoading(false); // Deactivate loading indicator after data is fetched
            })
            .catch((error) => {
                console.error("Failed to fetch project details:", error);
                isLoading(false); // Deactivate loading indicator on error
            });
    }

    const loadRoleList = () => {
        rolesList().then((res) => {
            if (res?.data?.code === "UASI0000") {
                const clientRole = res?.data?.data?.roles.find(
                    (role) => role?.name === "Client"
                );
                if (clientRole) {
                    clientList({ roleId: clientRole?.id }).then((r) => {
                        if (r?.data?.code === "RCI0000") {
                            const updatedClients = r?.data?.data
                                ?.filter((user) => user?.status !== "ARCHIVED")
                                ?.map((user) => ({
                                    id: user?.id,
                                    name: user?.name,
                                }))
                                ?.sort((a, b) => a.name.localeCompare(b.name));
                            // console.log(updatedClients)
                            setClients(updatedClients);
                        }
                    });
                } else {
                    console.log("Client role not found");
                }
            }
        });
    }

    const loadBudgetType = () => {
        getCompanySetting()
            .then((res) => {
                if (res.data.code === "RCI0000") {
                    setDefaultBudgetType(res.data.data.preferences.budgetType);
                } else {
                    setDefaultBudgetType("all");
                }
            });
    }

    useEffect(() => {
        loadBudgetType()
        loadProjectById(id)
        loadTag()
        loadRoleList()
    }, []);

    useEffect(() => {
        getProjectMember(id)
            .then((response) => {
                if (response.data && response.data.data) {
                    // console.log(typeof response.data.data);
                    let members = response?.data?.data;
                    setMembersList(members?.members || []);
                    setSavedMemberList(members?.members || []);
                }
            })
            .catch((error) => {
                console.error("Failed to fetch project members:", error);
            });
    }, [id]);


    const [newTag, setNewTag] = useState({
        name: "",
        color: "",
        iconUrl: "",
    });

    const handleBudgetType = (e) => {
        const newBudgetType = e.target.value;
        if (newBudgetType === "time") {
            setProjectData({ ...projectData, costBudget: 0, budgetType: newBudgetType });
        } else if (newBudgetType === "cost") {
            setProjectData({ ...projectData, timeBudget: 0, budgetType: newBudgetType });
        }
        setProjectErrors({ ...projectErrors, timeBudget: "" })
    };

    const handleFile = (event) => {
        handleFileError("");

        const file = event.target.files[0];
        if (!file) {
            return;
        }

        if (!/\/(jpeg|jpg|png)$/i.test(file.type)) {
            handleFileError(t("RAL0059"));
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            handleFileError(t("RAL0060"));
            event.target.value = "";
            return;
        }

        try {
            setTagIcon(URL.createObjectURL(file));
            setTagIconFile(file);
            handleFileError("");
        } catch (error) {
            console.error("Error during file upload", error);
            handleFileError(t("RAL0061"));
        }
        event.target.value = "";
    };
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleFileError = (message) => {
        setError(message);
    };
    const handleAddChange = (e) => {
        const value = e.target.value;
        setNewTag({ ...newTag, name: value });
        setError("");
    };
    const handleClose = (e) => {
        e.stopPropagation();
        setAnchorEl(null);
    };

    const handleEmojiSelect = (emojiObject) => {
        setTagIcon(null);
        setSelectedEmoji(emojiObject);
        EmojiPopupState.close();
        setShowEmojiPicker(false);
    };
    const EmojiPopupState = usePopupState({
        variant: "popover",
        popupId: "demo-popup-popover",
    });
    const handleCheckboxChange = (e) => {
        // if (e.target.checked) {
        //     setProjectData({
        //         ...projectData,
        //         endDate: null
        //     })
        // }
        setIsRecurring(e.target.checked);
        setProjectErrors({
            ...projectErrors,
            endDate: ""
        })
    };

    useEffect(() => {
        if (isSelectOpen) {
            const temp = [...tagOptions];
            setTagOptions(temp);
        }
    }, [tagOptions.length, isSelectOpen]);
    const handleBillableTypeChange = (value) => {
        setBillableType(value);
        setProjectErrors({ ...projectErrors, billableType: "" })
    };

    const resetOnAdd = () => {
        toast.success(t("RAL0197"));
        setError("");
        setNewTag({ name: "", color: "", iconUrl: "", });
        setSelectedEmoji(null);
        setTagIcon(null);
        setTagIconFile(null);
    };

    const handleAddNewTag = () => {
        if (!newTag.name.trim()) {
            setError(t("RAL0194"));
            return;
        }

        const payload = {
            name: newTag.name,
            color: newTag.color,
            iconUrl: selectedEmoji
                ? selectedEmoji.imageUrl
                : "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='18' height='17.998' viewBox='0 0 18 17.998'%3e%3cpath id='Subtraction_258' data-name='Subtraction 258' d='M17638.271%2c9060.5a2.493%2c2.493%2c0%2c0%2c1-1.781-.737l-7.795-7.785a.679.679%2c0%2c0%2c1-.2-.474v-8.332a.672.672%2c0%2c0%2c1%2c.67-.67h8.336a.654.654%2c0%2c0%2c1%2c.469.192l7.713%2c7.721v.046l.078.077a2.519%2c2.519%2c0%2c0%2c1%2c0%2c3.558l-5.713%2c5.667A2.506%2c2.506%2c0%2c0%2c1%2c17638.271%2c9060.5Zm-8.434-16.663h0v7.395l7.594%2c7.583a1.186%2c1.186%2c0%2c0%2c0%2c1.668%2c0l5.721-5.716a1.154%2c1.154%2c0%2c0%2c0%2c.342-.825%2c1.192%2c1.192%2c0%2c0%2c0-.342-.843l-7.594-7.594Zm3.5%2c4.629a1.13%2c1.13%2c0%2c1%2c1%2c1.129-1.13A1.135%2c1.135%2c0%2c0%2c1%2c17633.338%2c9048.465Z' transform='translate(-17628.5 -9042.501)' fill='%23a7a7a7'/%3e%3c/svg%3e", // Assuming selectedEmoji has the imageUrl property
        };
        createTag(payload)
            .then((res) => {
                if (res.data.code === "RCI0022") {
                    const newTagId = res.data.data.id;
                    const newTagObj = {
                        id: newTagId,
                        name: newTag.name.trim(),
                        url: payload.iconUrl,
                    };

                    setTagOptions(prev => [...prev, newTagObj]);
                    setSelectedTags(prev => [...prev, newTagId]);
                    setProjectData(prev => ({
                        ...prev,
                        tags: [...prev.tags, newTagId],
                    }));

                    if (tagIconFile) {
                        const formData = new FormData();
                        formData.append("file", tagIconFile);
                        uploadTagIconById(newTagId, formData)
                            .then(() => {
                                loadTag();
                            })
                            .catch(console.error);
                    }

                    resetOnAdd();
                    toast.success(t("RAL0197"));
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch(error => {
                console.error("Tag creation failed:", error);
                toast.error(t("RAL0323"));
            });
    };

    const onDateChange = (key, date) => {
        // console.log(date && date.isValid() ? date.toDate() : null)
        if (date === null || date === "" || (date && isNaN(date.valueOf()))) {
            setProjectData({ ...projectData, [key]: null });
            setProjectErrors((prevErrors) => ({
                ...prevErrors,
                [key]: t("RAL0552"),
            }));
        } else {
            setProjectData({ ...projectData, [key]: date && date.isValid() ? date.toDate() : null });
            setProjectErrors((prevErrors) => ({
                ...prevErrors,
                [key]: "",
            }));
        }
    };

    const clearNewTagFields = () => {
        setError("");
        setNewTag({
            name: "",
            color: "",
            iconUrl: "",
        });
        setSelectedEmoji(null); // Reset selected emoji
    }

    const handleCloseCancelDialog = () => {
        setIsCancelDialogOpen(false);
    };

    const handleConfirmCancel = () => {
        setIsCancelDialogOpen(false);
        if (fromView === "list") {
            navigate("/projects-list");
        } else {
            navigate("/projects");
        }
    };

    const handleCancelButton = () => {
        const formTagsIds = formData?.tags?.map(tId => tId.id) || [];

        const hasDifferentMember = projectData?.members?.some(pm => {
            return savedMemberList.some(sm => sm.id === pm.id && sm.cost === pm.cost);
        });

        const isSame = (
            formData.name == projectData.name &&
            formData.color == projectData.color &&
            formData.objective == projectData.objective &&
            formData.description == projectData.description &&
            formData?.client?.id == clientId &&
            formData.startDate == projectData.startDate &&
            formData?.endDate == projectData?.endDate &&
            formTagsIds?.every(id => selectedTags?.includes(id)) &&
            selectedTags?.every(id => formTagsIds?.includes(id)) &&
            savedMemberList?.length == projectData?.members?.length &&
            formData?.budgetType == projectData?.budgetType &&
            formData?.timeBudget == projectData?.timeBudget &&
            formData?.costBudget == projectData?.costBudget &&
            billableType == formData?.billableType &&
            hasDifferentMember &&
            formData?.isRecurringEndDate == isRecurring
        );
        if (!isSame) {
            setIsCancelDialogOpen(true);
        } else {
            window.history.go(-1);
        }
    };

    const handleEditProject = () => {
        let members = membersList;
        if (membersList.length > 0) {
            members?.forEach((m) => {
                if (CommonUtil.isEmptyString(m.cost)) {
                    m.cost = 0;
                }
            });
        }
        const {
            name,
            color,
            startDate,
            endDate,
            description,
            tags,
            budgetType,
            timeBudget,
            costBudget,
            objective
        } = projectData;
        const newErrors = {};
        let firstErrorAccordion = null;
        if (!name || name.trim() === "") {
            newErrors.name = t("RAL0558");
            if (!firstErrorAccordion) firstErrorAccordion = "basic";
        }
        if (!color || color.trim() === "") {
            newErrors.color = t("RAL0559");
            if (!firstErrorAccordion) firstErrorAccordion = "basic";
        }
        if (!startDate) {
            newErrors.startDate = t("RAL0551");
            if (!firstErrorAccordion) firstErrorAccordion = "basic";
        }

        if (!objective?.trim()) {
            newErrors.objective = t("RAL0001");
            if (!firstErrorAccordion) firstErrorAccordion = "details";
        }

        if (!startDate) {
            newErrors.startDate = t("RAL0551");
            if (!firstErrorAccordion) firstErrorAccordion = "basic";
        }

        if (!endDate && !isRecurring) {
            newErrors.endDate = t("RAL0552");
            if (!firstErrorAccordion) firstErrorAccordion = "basic";
        }

        if (startDate && endDate &&
            startDate >= endDate && !isRecurring
        ) {
            newErrors.startDate = t("RAL0553");
            newErrors.endDate = t("RAL0554");

            if (!firstErrorAccordion) firstErrorAccordion = "basic";
        }
        if (description?.length > 2000) {
            newErrors.description = t("RAL0550");
            if (!firstErrorAccordion) firstErrorAccordion = "details";
        }
        if (startDate && endDate && new Date(startDate) >= new Date(endDate)) {
            newErrors.startDate = t("RAL0560");
            newErrors.endDate = t("RAL0561");
            if (!firstErrorAccordion) firstErrorAccordion = "basic";
        }
        if (defaultBudgetType === "all" || defaultBudgetType === 'time') {
            if (projectData.budgetType === "time") {
                if (!projectData.timeBudget || projectData.timeBudget <= 0) {
                    newErrors.timeBudget = t("RAL0774");
                    firstErrorAccordion = firstErrorAccordion || "budget";
                } else if (projectData.timeBudget > 50000) {
                    newErrors.timeBudget = t("RAL0745");
                    firstErrorAccordion = firstErrorAccordion || "budget";
                }
            }
        }
        if (defaultBudgetType != currentBudgetType && defaultBudgetType === 'time') {
            if (projectData.budgetType === "cost") {
                if (!projectData.timeBudget || projectData.timeBudget <= 0) {
                    newErrors.timeBudget = t("RAL0774");
                    firstErrorAccordion = firstErrorAccordion || "budget";
                } else if (projectData.timeBudget > 50000) {
                    newErrors.timeBudget = t("RAL0745");
                    firstErrorAccordion = firstErrorAccordion || "budget";
                }
            }
        }

        if (Object.keys(newErrors).length > 0) {
            setProjectErrors((prevErrors) => ({
                ...prevErrors,
                ...newErrors,
            }));

            if (firstErrorAccordion) {
                setExpandedAccordion(firstErrorAccordion);
            }
            return;
        }
        if (projectData.members?.length <= 0) {
            toast.error(t("RAL0303"));
            return;
        }

        // checking if selected member is there in active user list
        const filteredMembers = userList?.map((m) => m.id);
        const prjMem = projectData?.members?.filter(v => filteredMembers.includes(v.id));

        let updatedProjectData = {
            ...projectData,
            tags: selectedTags,
            members: prjMem,
            clientName: clientId,
            billableType: billableType,
            endDate: isRecurring ? null : endDate,
        };
        if (defaultBudgetType === "all") {
            updatedProjectData = {
                ...updatedProjectData,
                budgetType: projectData.budgetType,
                timeBudget: projectData.budgetType === "time" ? projectData.timeBudget : 0,
                costBudget: projectData.budgetType === "cost" ? projectData.costBudget : 0,
            };
        } else if (defaultBudgetType === 'time') {
            updatedProjectData = {
                ...updatedProjectData,
                budgetType: defaultBudgetType,
                timeBudget: defaultBudgetType === "time" ? projectData.timeBudget : 0,
            };
        } else {
            updatedProjectData = {
                ...updatedProjectData,
                budgetType: defaultBudgetType,
                costBudget: defaultBudgetType === "cost" ? projectData.costBudget : 0,
            };
        }

        setSaveButtonDisable(true);
        editProject(id, updatedProjectData)
            .then((response) => {
                setSaveButtonDisable(false);
                if (response.data.code === "RCI0034") {
                    toast.success(t("RAL0322"));
                    if (fromView === "list") {
                        navigate("/projects-list");
                    } else {
                        navigate("/projects");
                    }
                } else {
                    setProjectErrors((prevErrors) => {
                        const newErrors = { ...prevErrors };

                        if (["RCE0135", "RCE0136"].includes(response.data.code)) {
                            newErrors.description = response.data.message;
                        } else {
                            newErrors.description = "";
                        }

                        if (response.data.code === "RCE0137") {
                            newErrors.color = response.data.message;
                        } else {
                            newErrors.color = "";
                        }

                        if (
                            ["RCE0130", "RCE0132", "RCE0133", "RCE0146"].includes(
                                response.data.code
                            )
                        ) {
                            newErrors.name = response.data.message;
                        } else {
                            newErrors.name = "";
                        }

                        return newErrors;
                    });
                }
            })
            .catch((error) => {
                console.error("Error editing project:", error);
                toast.error(t("RAL0323"));
            });
    };
    return (
        <>
            <TitleBar
                id="header-text-add-project"
                title={t("RAL0287")}
                navBack={true}
                onBackClick={handleCancelButton}
            ></TitleBar>
            <div className="addnewproject">
                <Accordion className="accordion"
                    expanded={expandedAccordion === "basic"}
                    onChange={(_, isExpanded) =>
                        setExpandedAccordion(isExpanded ? "basic" : null)
                    }
                    square={false}
                    elevation={0}
                    sx={{
                        "&.MuiAccordion-root": {
                            "::before": {
                                content: "none",
                            },
                        },
                    }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <div className="accordion-text-column">
                            <span className="labeladdbasic">{t("RAL1016")}</span>
                            <span className={mode === "dark" ? "descriptionaddbasicDark" : "descriptionaddbasic"}>{t("RAL1017")}</span>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div>
                            <div className="projectfirlcolorpicker">
                                <div className="projecttextfield1">
                                    <CustomTextField
                                        id="text-create-projectname"
                                        label={t("RAL0289")}
                                        placeholder={t("RAL0290")}
                                        value={projectData.name}
                                        error={projectErrors.name}
                                        helperText={projectErrors.name}
                                        onChange={(e) => {
                                            setProjectData({
                                                ...projectData,
                                                name: e.target.value
                                            });
                                            setProjectErrors({
                                                ...projectErrors,
                                                name: ""
                                            })
                                        }}
                                        inputProps={{
                                            maxLength: 50,
                                        }}
                                    />
                                </div>
                                <div className="colorLabelproject">
                                    <label id="text-project-color" className={mode === "dark" ? "colorLabelproDark" : "colorLabelpro"}>
                                        {t("RAL0291")}
                                    </label>
                                    <div className="colorPickerproject" onClick={handleClick}>
                                        <Box
                                            sx={{
                                                backgroundColor: projectData.color,
                                                width: "86px",
                                                height: "19px",
                                                borderRadius: "2px",
                                                ...(projectData.color &&
                                                    projectData.color.startsWith("#f") && {
                                                    border: "1px solid #E0E0E0",
                                                }),
                                                ...(projectData.color &&
                                                    projectData.color.startsWith("#00") && {
                                                    border: "1px solid #000000",
                                                }),
                                            }}
                                        ></Box>
                                        {anchorEl ? <ArrowUp className="arrowupanddown" /> : <DownArrow className="arrowupanddown" />}
                                        <Popover
                                            open={Boolean(anchorEl)}
                                            anchorEl={anchorEl}
                                            onClose={(e) => handleClose(e)}
                                            anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "right",
                                            }}
                                            transformOrigin={{
                                                vertical: "top",
                                                horizontal: "right",
                                            }}
                                            disableRestoreFocus
                                            sx={{ zIndex: 1000 }}
                                        >
                                            <div>
                                                <ColorPickerWithPalettes
                                                    selectedColor={projectData.color}
                                                    setSelectedColor={(e) => setProjectData({ ...projectData, color: e })}
                                                    onClose={handleClose}
                                                />
                                            </div>
                                        </Popover>
                                    </div>
                                </div>
                            </div>
                            <div className="datepicker-dimension">
                                <div className="datepicker-dimension11">

                                    <CustomizedDatePicker
                                        required={true}
                                        id="btn-date-project"
                                        name="btn-date-project"
                                        label={t("RAL0294")}
                                        placeholder={t("RAL1039")}
                                        value={projectData.startDate}
                                        error={Boolean(projectErrors.startDate)}
                                        helperText={projectErrors.startDate || ""}
                                        onChange={(e) => onDateChange("startDate", e)}
                                    // maxDate={projectData.startDate || ""}
                                    />
                                </div>
                                <div className="datepicker-dimension11">
                                    <CustomizedDatePicker
                                        required={true}
                                        id="btn-date-project"
                                        name="btn-date-project"
                                        disabled={isRecurring}
                                        label={t("RAL0295")}
                                        placeholder={t("RAL1040")}
                                        value={projectData.endDate}
                                        onChange={(e) => onDateChange("endDate", e)}
                                        error={Boolean(projectErrors.endDate)}
                                        helperText={projectErrors.endDate || ""}
                                        // minDate={projectData.startDate || ""}
                                        minDate={new Date()}
                                    />
                                    <span className="checkmarkboxdesk">
                                        <Checkbox className="checkmarkboxdesk11"
                                            checked={isRecurring}
                                            onChange={handleCheckboxChange} />
                                        {t("RAL1018")}
                                    </span>

                                </div>
                            </div>
                            <div className="addprojectclient">
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <label id="project-text-client">{t("RAL0296")}</label>
                                </Box>
                                <CustomAutoComplete
                                    id="dropdown-project-create-client"
                                    options={clients || []}
                                    placeholder={t("RAL0655")}
                                    value={clientId}
                                    onChange={setClientId}
                                    handleClear={() => setClientId("")}
                                />
                            </div>
                        </div>
                    </AccordionDetails>
                </Accordion>
                <Accordion className="accordion"
                    expanded={expandedAccordion === "details"}
                    onChange={(_, isExpanded) =>
                        setExpandedAccordion(isExpanded ? "details" : null)
                    }

                    square="false"
                    elevation={0}
                    sx={{
                        "&.MuiAccordion-root": {
                            "::before": {
                                content: "none",
                            },
                        },
                    }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <div className="accordion-text-column">
                            <span className="labeladdbasic">{t("RAL1019")}</span>
                            <span className={mode === "dark" ? "descriptionaddbasicDark" : "descriptionaddbasic"}>{t("RAL1020")}</span>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div>
                            <div className="objectiveproject">
                                <CustomTextField
                                    label={t("RAL1021")}
                                    placeholder={t("RAL1022")}
                                    value={projectData.objective}
                                    required={true}
                                    error={projectErrors.objective}
                                    helperText={projectErrors.objective}
                                    onChange={(e) => {
                                        setProjectData({
                                            ...projectData,
                                            objective: e.target.value
                                        });
                                        setProjectErrors({
                                            ...projectErrors,
                                            objective: ""
                                        })
                                    }}
                                    inputProps={{
                                        maxLength: 255,
                                    }}
                                />
                            </div>
                            <div className="project-description-wrapper">
                                <CustomTextField
                                    id="text-project-description"
                                    name="Description"
                                    label={t("RAL0292")}
                                    rows={1}
                                    placeholder={t("RAL0293")}
                                    multiline
                                    inputProps={{ maxLength: 2000 }}
                                    className="project-description-field"
                                    value={projectData.description}
                                    error={projectErrors.description}
                                    helperText={projectErrors.description}
                                    onChange={(e) => {
                                        setProjectData({
                                            ...projectData,
                                            description: e.target.value
                                        });
                                        setProjectErrors({
                                            ...projectErrors,
                                            description: ""
                                        })
                                    }}
                                />
                                <div className="project-description-counter">{projectData?.description ? projectData?.description?.length : 0}/2000</div>
                            </div>
                            <div className="addprojecttagss">
                                <Box><label id="project-text-client">{t("RAL0191")}</label></Box>
                                <FormControl
                                    fullWidth
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                        },
                                    }}
                                >
                                    <Select
                                        ref={selectRef}
                                        open={isSelectOpen}
                                        onOpen={() => setIsSelectOpen(true)}
                                        onClose={(event) => {
                                            if (selectedTags?.length == 0) {
                                                setIsSelectOpen(false);
                                            }
                                        }}
                                        displayEmpty
                                        id="dropdown-clientfilter"
                                        value={selectedTags || []}
                                        onChange={(event) => {
                                            event.defaultPrevented()
                                            const value = event.target.value;
                                            setSelectedTags(typeof value === 'string' ? value.split(',') : value);
                                        }}
                                        renderValue={(selected = []) => {
                                            if (selected.length === 0) {
                                                return <Box sx={{ color: mode === "dark" ? "#f8f8f880" : "#24242480", }}>{t('RAL1036')}</Box>;
                                            }
                                            const selectedTagObjects = tagOptions.filter(tag => selected.includes(tag.id));
                                            return (
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        gap: "8px",
                                                        maxHeight: "80px",
                                                        overflowY: "auto",
                                                        alignItems: "flex-start"
                                                    }}
                                                >
                                                    {selected.map(tagId => {
                                                        const tag = tagOptions.find(t => t.id === tagId);
                                                        if (!tag) return null;
                                                        return (
                                                            <Box
                                                                key={tag.id}
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    backgroundColor: mode === "dark" ? "#000" : "#fff",
                                                                    borderRadius: "6px",
                                                                    padding: "4px 8px",
                                                                    fontSize: "14px",
                                                                    maxWidth: "170px",
                                                                    overflow: "hidden",
                                                                    pointerEvents: 'auto',
                                                                    '& > *': {
                                                                        pointerEvents: 'auto',
                                                                    }
                                                                }}
                                                                onMouseDown={(e) => {
                                                                    e.stopPropagation();
                                                                    e.preventDefault();
                                                                }}
                                                            >
                                                                <img
                                                                    src={tag?.url ? tag?.url : TagIcon}
                                                                    alt={tag?.name}
                                                                    style={{ width: "16px", height: "16px", marginRight: "6px" }} />
                                                                <Tooltip title={tag.name}>
                                                                    <span style={{
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        maxWidth: "90px"
                                                                    }}>
                                                                        {tag.name}
                                                                    </span>
                                                                </Tooltip>
                                                                <CloseIcon
                                                                    onMouseDown={(e) => {
                                                                        e.stopPropagation();
                                                                        e.preventDefault();
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setSelectedTags(prev => prev.filter(id => id !== tag.id));
                                                                        setProjectData(prev => (
                                                                            {
                                                                                ...projectData, tags: prev?.tags?.filter(id => id !== tag.id)
                                                                            }));
                                                                    }}
                                                                    sx={{
                                                                        fontSize: "16px",
                                                                        marginLeft: "6px",
                                                                        cursor: "pointer",
                                                                        color: "#999",
                                                                        '&:hover': {
                                                                            color: "red",
                                                                        },
                                                                        pointerEvents: 'auto',
                                                                    }} />

                                                            </Box>
                                                        )
                                                    })}
                                                </Box>
                                            );
                                        }}
                                        className="allClientsDropdown"
                                        MenuProps={{
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            },
                                            transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'left',
                                            },
                                            PaperProps: {
                                                style: {
                                                    borderRadius: "5px",
                                                    maxHeight: "400px",
                                                },
                                            },
                                            disableAutoFocusItem: true,
                                            autoFocus: false,
                                        }}
                                        multiple
                                        sx={{
                                            borderRadius: "5px",
                                            background: mode === "light" ? "var(--color-42)" : "var(--color-47-50)",
                                            font: "normal normal normal 16px/20px Gotham",
                                            "& .MuiSelect-select": {
                                                display: "flex",
                                                flexWrap: "wrap",
                                                gap: "8px",
                                                alignItems: "flex-start",
                                                overflowY: "auto",
                                                maxHeight: "100px",
                                                color: mode === "light"
                                                    ? "var(--color-43) !important"
                                                    : "var(--color-33-80) !important",
                                            },
                                        }}
                                    >
                                        <Box onKeyDown={(e) => e.stopPropagation()} sx={{ padding: "20px 20px 0 20px" }}>
                                            <TextField
                                                className={mode === "dark" ? "projectSelectMem1234Dark" : "projectSelectMem1234"}
                                                id="select-check-clientfilter"
                                                placeholder={t("RAL0192")}
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                value={tagSearchValue}
                                                autoComplete="off"
                                                onChange={(e) => SetTagSearchValue(e.target.value)}
                                                InputLabelProps={{ shrink: false }}
                                                InputProps={{
                                                    onClick: (e) => {
                                                        e.stopPropagation();
                                                    },
                                                    endAdornment: tagSearchValue && (
                                                        <CloseIcon
                                                            onClick={() => SetTagSearchValue("")}
                                                            className="timeerrorduimension11"
                                                        />
                                                    ),
                                                }}
                                                inputProps={{
                                                    maxLength: 20
                                                }}
                                            />
                                            <Box
                                                className="taglist-selected1">
                                                <Typography sx={{
                                                    color: mode === "light" ? "#242424" : "#f8f8f880",
                                                    fontFamily: "Gotham"
                                                }}>
                                                    {t("RAL1027")}
                                                </Typography>
                                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                                    <Typography
                                                        sx={{
                                                            fontFamily: "Gotham",
                                                            color: mode === "light" ? "#1D0B77" : "auto",
                                                            cursor: "default"
                                                        }}
                                                    >
                                                        {selectedTags?.length ? selectedTags?.length : 0} {t("RAL0934")}
                                                    </Typography>
                                                    <Tooltip title={t("RAL0693")}>
                                                        <CloseIcon
                                                            className="timeerrorduimension11"
                                                            onClick={() => setSelectedTags([])}
                                                        />
                                                    </Tooltip>
                                                </Box>
                                            </Box>
                                            <div className={mode === "dark" ? "dividerbillingcarddark111" : "dividerbillingcard111"}></div>
                                        </Box>

                                        <Box sx={{
                                            maxHeight: 200,
                                            overflowY: "auto",
                                            scrollbarWidth: "thin",
                                            scrollbarColor: "var(--background-color-38) transparent",
                                            "&::-webkit-scrollbar": {
                                                width: "8px",
                                                backgroundColor: "transparent",
                                            },
                                            "&::-webkit-scrollbar-thumb": {
                                                borderRadius: "10px",
                                            },
                                        }}>
                                            {tagOptions && (
                                                tagOptions.filter(tag =>
                                                    tag.name?.toLowerCase().includes(tagSearchValue?.toLowerCase())
                                                ).length > 0 ? (
                                                    tagOptions
                                                        .filter(tag =>
                                                            tag.name?.toLowerCase().includes(tagSearchValue?.toLowerCase())
                                                        )
                                                        .map((tag) => (
                                                            <MenuItem
                                                                id={`select-item-tagfilter-${tag.name}`}
                                                                key={tag.id}
                                                                value={tag.id}
                                                                onClick={(e) => {
                                                                    setSelectedTags(prev =>
                                                                        prev?.includes(tag.id)
                                                                            ? prev.filter(id => id !== tag.id)
                                                                            : [...prev, tag.id]
                                                                    );
                                                                }}
                                                                selected={selectedTags?.includes(tag.id)}
                                                                className={mode === "dark" ? "handle-tafchangedark" : "handle-tafchange"}
                                                            >
                                                                <Checkbox
                                                                    id={`select-item-check-tagfilter-${tag.name}`}
                                                                    checked={selectedTags?.includes(tag.id)}
                                                                    className="select-item-check-tagfilter"
                                                                />
                                                                <img
                                                                    id="project-image-tags"
                                                                    src={tag?.url ? tag?.url : TagIcon}
                                                                    alt={tag?.name}
                                                                    style={{ width: "18px", height: "18px", margin: " 0 10px" }}
                                                                />
                                                                {tag.name.length > 22 ? (
                                                                    <Tooltip
                                                                        id={`select-item-tagfilter-${tag.name}`}
                                                                        title={tag.name}
                                                                        placement="top"
                                                                    >
                                                                        <span id={`select-item-tagfilter-${tag.name}`}>
                                                                            {`${tag.name.substring(0, 22)}...`}
                                                                        </span>
                                                                    </Tooltip>
                                                                ) : (
                                                                    tag.name
                                                                )}
                                                            </MenuItem>
                                                        ))
                                                ) : (
                                                    <MenuItem disabled className="menu-item-notags">
                                                        {t("RAL0522")}
                                                    </MenuItem>
                                                )
                                            )}
                                        </Box>
                                        <div style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            marginTop: "20px",
                                            width: "98%",
                                        }}>
                                            <CustomButton
                                                place="sp-cancel"
                                                variant="outlined"
                                                class="memberSaveButton"
                                                id="btn-cancel-member-list"
                                                name="btn-cancel-member-list"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setIsSelectOpen(false);
                                                    setSelectedTags(projectData?.tags[0]?.id ? projectData?.tags?.map(tId => tId.id) : projectData?.tags)
                                                    SetTagSearchValue("")
                                                    selectRef.current?.blur();
                                                }}
                                            >
                                                {t("RAL0177")}
                                            </CustomButton>
                                            <CustomButton
                                                variant="contained"
                                                class="memberCancelButton"
                                                id="btn-save-member-list"
                                                name="btn-save-member-list"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setIsSelectOpen(false);
                                                    setProjectData({ ...projectData, tags: selectedTags });
                                                    SetTagSearchValue("")
                                                    selectRef.current?.blur();
                                                }}
                                            >
                                                {t("RAL0677")}
                                            </CustomButton>
                                        </div>
                                    </Select>

                                </FormControl>
                            </div>
                            <div className="createtagsin">
                                <label id="text-project-add-tags">{t("RAL1023")}</label>
                                <div >
                                    <Box className="project-tags-add-wrapper" >
                                        <Box
                                            display={"flex"}
                                            alignItems={"center"}
                                            className={"new-tag " + (error ? "error-box" : "")}
                                            justifyContent={"center"}
                                            flexDirection={"row-reverse"}
                                        >
                                            <Box
                                                display={"flex"}
                                                flexGrow={1}
                                                className="tag-name"
                                                alignItems={"center"}
                                            >
                                                <Box item flexGrow={1}>
                                                    <ProjectTagTextField
                                                        id="textfield-tags-add"
                                                        label={t("RAL0194")}
                                                        error={!!error}
                                                        helperText={error}
                                                        value={newTag.name}
                                                        onChange={(e) => handleAddChange(e)}
                                                        inputProps={{
                                                            maxLength: 60,
                                                        }}
                                                        onClick={handleAddNewTag}
                                                        onCancelClick={() => clearNewTagFields()}
                                                    />
                                                </Box>
                                            </Box>
                                            <Box className="tag-icon-pointer"  {...bindTrigger(EmojiPopupState)}>
                                                <Box item flexGrow={1} className="DropdownIcon">
                                                    <input
                                                        id="text-tags-file"
                                                        type="file"
                                                        ref={fileInputRef}
                                                        onChange={handleFile}
                                                        style={{ display: "none" }}
                                                        accept="image/png, image/jpeg, image/jpg"
                                                    />
                                                    {selectedEmoji || tagIcon ? (
                                                        <Avatar
                                                            id={"tags-emoji-avatar"}
                                                            variant="square"
                                                            src={selectedEmoji ? selectedEmoji.imageUrl : tagIcon}
                                                            className="emojidimensions"
                                                            {...bindTrigger(EmojiPopupState)}
                                                        />
                                                    ) : (
                                                        <img
                                                            src={TagIcon}
                                                            alt="Tag icon"
                                                            className="emojidimensions"
                                                            {...bindTrigger(EmojiPopupState)}
                                                        />
                                                    )}
                                                </Box>
                                                <DownArrow
                                                    id={"tags-icon-arrowdown"}
                                                    {...bindTrigger(EmojiPopupState)}
                                                />
                                            </Box>
                                            <Popover
                                                {...bindPopover(EmojiPopupState)}
                                                anchorOrigin={{
                                                    vertical: "bottom",
                                                    horizontal: "left",
                                                }}
                                                disableRestoreFocus
                                                sx={{ zIndex: 1000 }}
                                            >
                                                <Emojipicker onEmojiSelect={handleEmojiSelect} />
                                            </Popover>
                                        </Box>
                                    </Box>
                                    {error && (
                                        <Box display={"flex"} alignItems={"center"} pt={0.5}>
                                            <Box item pr={0.5} mt={0.6}>
                                                <ErrorIcon />
                                            </Box>
                                            <Box display="flex" alignItems="center">
                                                <Typography id="tags-error-message" className="helper-text">
                                                    {error}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </div>
                            </div>


                        </div>
                    </AccordionDetails>
                </Accordion>
                <Accordion className="accordion"
                    expanded={expandedAccordion === "budget"}
                    onChange={(_, isExpanded) =>
                        setExpandedAccordion(isExpanded ? "budget" : null)
                    }

                    square="false"
                    elevation={0}
                    sx={{
                        "&.MuiAccordion-root": {
                            "::before": {
                                content: "none",
                            },
                        },
                    }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <div className="accordion-text-column">
                            <span className="labeladdbasic">{t("RAL1024")}</span>
                            <span className={mode === "dark" ? "descriptionaddbasicDark" : "descriptionaddbasic"}>{t("RAL1025")}</span>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div>
                            <FormControl >
                                <RadioGroup
                                    id="btn-toggle-radio-project"
                                    sx={{
                                        flexDirection: "column",
                                        display: "flex",
                                        gap: "20px",
                                    }}
                                    value={defaultBudgetType === "all" ? projectData.budgetType :
                                        defaultBudgetType != currentBudgetType ? defaultBudgetType
                                            : currentBudgetType}
                                    onChange={handleBudgetType}
                                >
                                    {(["time", "all"].includes(defaultBudgetType) ||
                                        defaultBudgetType != currentBudgetType) && <Box className="formacontrol-align">
                                            <FormControlLabel
                                                id="btn-radio-time-project"
                                                className="btn-radio-time-project"
                                                name="btn-radio-time-project"
                                                value="time"
                                                control={
                                                    <Radio
                                                        id="btn-radio-time-project"
                                                        sx={{ "&.Mui-checked": { color: "#FA9C2B" } }}
                                                    />
                                                }
                                                label={t("RAL0280")}
                                                disabled={defaultBudgetType === "all" ? false :
                                                    defaultBudgetType != currentBudgetType ? defaultBudgetType === "cost" ? true : false : false}
                                            />
                                            <Box mt={1} >
                                                <label id="project-text-budget">{t("RAL1026")}</label>
                                                <div>
                                                    <OutlinedInput
                                                        fullWidth
                                                        className="text-budget-project-cost"
                                                        name="text-budget-project-cost"
                                                        type="text"
                                                        placeholder={t("RAL1026")}
                                                        endAdornment={
                                                            <InputAdornment position="end">hr</InputAdornment>
                                                        }
                                                        // disabled={projectData.budgetType !== "time"}
                                                        disabled={defaultBudgetType === "all" ? projectData.budgetType !== "time" :
                                                            defaultBudgetType != currentBudgetType ? defaultBudgetType === "cost" ? true : false : false
                                                        }
                                                        // disabled={checkBudgetType()}
                                                        value={projectData.timeBudget}
                                                        onChange={(e) => {
                                                            let value = e.target.value;
                                                            value = value.replace(/[^0-9]/g, "");
                                                            if (value.length > 5) {
                                                                value = value.substring(0, 5);
                                                            }
                                                            if (value && value > 50000) {
                                                                setProjectErrors({
                                                                    ...projectErrors,
                                                                    timeBudget: t("RAL0745")
                                                                })
                                                            } else if (value && value < 1) {
                                                                setProjectErrors({
                                                                    ...projectErrors,
                                                                    timeBudget: t("RAL0774")
                                                                })
                                                            }
                                                            else {
                                                                setProjectErrors({
                                                                    ...projectErrors,
                                                                    timeBudget: ""
                                                                })
                                                            }
                                                            setProjectData({
                                                                ...projectData,
                                                                timeBudget: value
                                                            });
                                                        }}
                                                    />
                                                </div>
                                                <div className="error-container123">
                                                    {(defaultBudgetType != currentBudgetType || ["all", "time"].includes(defaultBudgetType)) &&
                                                        ["time", "cost"].includes(projectData.budgetType) && projectErrors.timeBudget !== ""
                                                        && (
                                                            <div className="timeerrorduimension">
                                                                <ErrorIcon />
                                                                {projectErrors.timeBudget}
                                                            </div>
                                                        )}
                                                </div>
                                            </Box>
                                        </Box>}
                                    {(["cost", "all"].includes(defaultBudgetType) ||
                                        defaultBudgetType != currentBudgetType) && <Box className="formacontrol-align">
                                            <FormControlLabel
                                                id="btn-radio-cost-project"
                                                className="btn-radio-time-project1"
                                                name="btn-radio-cost-project"
                                                value="cost"
                                                control={
                                                    <Radio
                                                        id="btn-radio-cost-project"
                                                        sx={{ "&.Mui-checked": { color: "#FA9C2B" } }}
                                                    />
                                                }
                                                disabled={defaultBudgetType === "all" ? false :
                                                    defaultBudgetType != currentBudgetType ? defaultBudgetType === "cost" ? false : true : false}
                                                label={t("RAL0297")}
                                            />
                                            <Box mt={1} >
                                                <label id="project-text-budget">{t("RAL0298")}</label>
                                                <div>
                                                    <OutlinedInput
                                                        fullWidth
                                                        className="text-budget-project-cost"
                                                        name="text-budget-project-cost"
                                                        type="text"
                                                        placeholder={t("RAL0298")}
                                                        endAdornment={
                                                            <InputAdornment position="end">$</InputAdornment>
                                                        }
                                                        disabled={defaultBudgetType === "all" ? projectData.budgetType !== "cost" :
                                                            defaultBudgetType != currentBudgetType ? defaultBudgetType === "cost" ? false : true : false
                                                        }
                                                        value={projectData.costBudget}
                                                        onChange={(e) => {
                                                            let value = e.target.value;

                                                            if (!/^\d{0,5}(\.\d{0,2})?$/.test(value)) {
                                                                return;
                                                            }
                                                            setProjectData({
                                                                ...projectData,
                                                                costBudget: value
                                                            });
                                                            setProjectErrors({
                                                                ...projectErrors,
                                                                costBudget: ""
                                                            });
                                                        }}
                                                    />
                                                </div>
                                                {(defaultBudgetType != currentBudgetType || ["all"].includes(defaultBudgetType)) &&
                                                    ["time", "cost"].includes(projectData.budgetType) && projectErrors.costBudget !== ""
                                                    && (
                                                        <span
                                                            style={{
                                                                color: "red",
                                                                marginTop: "5px",
                                                                fontSize: "12px",
                                                            }}
                                                        >
                                                            {projectErrors.costBudget}
                                                        </span>
                                                    )}
                                            </Box>
                                        </Box>}
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </AccordionDetails>
                </Accordion>

                <AddMembersComponent
                    className="accordion"
                    id="btn-toggle-exp-member"
                    selectedEmployee={(e) => {
                        setProjectData({ ...projectData, members: e });
                        setProjectErrors({ ...projectErrors, members: "" })
                    }}
                    EditData={savedMemberList}
                    isEditForm={true}
                    billableType={handleBillableTypeChange}
                    billableCostData={projectData.billableType}
                    expanded={expandedAccordion === "members"}
                    onChange={(_, isExpanded) =>
                        setExpandedAccordion(isExpanded ? "members" : null)
                    }
                    setUserList={setUserList}
                />
            </div>
            <Grid
                container
                item
                xs={12}
                lg={12}
                spacing={3}
                alignItems={"end"}
                justifyContent={"flex-end"}
                mt={1}
                mb={2}
            >
                <Grid
                    sx={{
                        position: "sticky",
                        bottom: "1.5rem",
                    }}
                >
                    <CustomButton
                        place="sp-cancel"
                        variant="outlined"
                        class="memberButton"
                        id="btn-cancel-project"
                        name="btn-cancel-project"
                        onClick={handleCancelButton}
                    >
                        {t("RAL0177")}
                    </CustomButton>
                    <CustomButton
                        variant={"contained"}
                        class="memberButton"
                        id="btn-add-project"
                        name="btn-add-project"
                        onClick={handleEditProject}
                        disabled={isSaveButtonDisable}
                    >
                        {t("RAL0309")}
                    </CustomButton>
                </Grid>
                {isCancelDialogOpen && <CancelDialog
                    open={isCancelDialogOpen}
                    onClose={handleCloseCancelDialog}
                    onConfirm={handleConfirmCancel}
                    header={t("RAL0382")}
                    message={t("RAL0378")}
                />}
            </Grid>
        </>
    );
}